import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailPeopleProps as Props } from './types';
import type { CompanyPerson } from '../../../types/companyDetail';
import { getCompanyPeople } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [companyPeople, setCompanyPeople] = useState<CompanyPerson[]>([]);

  useEffect(() => {
    let aborted = false;

    const fetchPeople = async () => {
      try {
        const response = await getCompanyPeople(props.company.id);
        if (aborted) return;
        setCompanyPeople(Array.isArray(response.companyPeople) ? response.companyPeople : []);
        props.setIdCount('memberIds', response.companyPeople?.length ?? 0);
      } catch (error) {
        console.log(error);
      }
    };

    fetchPeople();
    return () => {
      aborted = true;
    };
  }, [props.company.id, props.setIdCount]);

  return (
    <Presentation
      companyPeople={companyPeople}
      iconNoImg={props.iconNoImg}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};
